<template>
  <div
    id="layout"
    class="antialiased bg-white text-stone-900 font-sans border-b overflow-x-hidden md:overflow-x-auto"
  >
    <client-only>
      <Sidebars />
    </client-only>

    <header>
      <ErrorBoundary>
        <client-only>
          <Notifications />
        </client-only>
        <Navbar />
      </ErrorBoundary>
      <slot name="banner" />
    </header>

    <ErrorBoundary>
      <main>
        <PageLoader />
        <slot />
      </main>
    </ErrorBoundary>

    <slot name="links-section">
      <ErrorBoundary>
        <NuxtLazyHydrate when-visible>
          <EventListLinksBlock />
        </NuxtLazyHydrate>
      </ErrorBoundary>
    </slot>
    <slot name="footer">
      <ErrorBoundary>
        <NuxtLazyHydrate when-visible>
          <Footer :footer-block-items="footerBlock" />
        </NuxtLazyHydrate>
      </ErrorBoundary>
    </slot>
  </div>
</template>
<script lang="ts" setup>
const { locale } = useI18n()

const { data: footerData } = await useStrapiSingleType(
  `footer?locale=${locale.value}&populate[footerBlock][populate]=*`
)

const { setupValidationPolling, deactivateValidationPolling } =
  useCartValidation()

const { footerBlock = [] } = footerData?.value?.data || {}

onMounted(async () => {
  await setupValidationPolling()
})

onUnmounted(async () => {
  await deactivateValidationPolling()
})

useLayoutHead()
</script>

<style lang="postcss" scoped>
#layout {
  box-sizing: border-box;
}

header {
  @apply sticky top-0 z-20;
}

main {
  min-height: 100vh;
  position: relative;
}
</style>

<style>
.Toastify__toast-container {
  max-width: 480px;
  --toastify-toast-width: max-content;
}
</style>
